import { Injectable, OnInit } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApiService } from '../../shared/services/index';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ReportTypeService {}
